import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { LoginConnectorApollo, UserDataConnectorApollo } from '@front-activerse/common-components';
import AuthLoginByEmailAndPasswordForm from '../../Auth/Login/AuthLoginByEmailAndPasswordForm';

interface IActiveProductLoginContainer {
  pathActiveProduct: string;
}

const ActiveProductLoginContainer: React.FC<IActiveProductLoginContainer> = ({
  pathActiveProduct,
}) => {
  const [searchParams] = useSearchParams();
  const coupon = searchParams.get('coupon');
  const redirectPath = coupon
    ? `${pathActiveProduct}?coupon=${encodeURIComponent(coupon)}`
    : pathActiveProduct;

  return (
    <LoginConnectorApollo>
      {({ ...login }: { login: any }) => (
        <UserDataConnectorApollo>
          {({ ...userDataOnDemand }: { userDataOnDemand: any }) => (
            <AuthLoginByEmailAndPasswordForm
              {...userDataOnDemand}
              login={login.login}
              userDataOnDemand={userDataOnDemand.userDataOnDemand}
              redirectToPathAfterSuccess={redirectPath}
            />
          )}
        </UserDataConnectorApollo>
      )}
    </LoginConnectorApollo>
  );
};

export default ActiveProductLoginContainer;
